import { dateFormat } from '@/shared/lib/helpers/date-format.helper';

interface GenerateTextArgs {
	defaultLabel: string;
	label?: string;
	startDate?: Date;
	endDate?: Date;
}

export const generateText = ({ defaultLabel, label, startDate, endDate }: GenerateTextArgs) => {
	if (label) {
		return label;
	}
	if (startDate && endDate) {
		return `From: ${dateFormat(startDate)} To: ${dateFormat(endDate)}`;
	}
	if (startDate) {
		return `From: ${dateFormat(startDate)}`;
	}
	if (endDate) {
		return `To: ${dateFormat(endDate)}`;
	}

	return defaultLabel;
};
